import store from '@/store/index.js';
import i18nOptions from './i18nOptions.utils.js';
import VueI18n from 'vue-i18n';
import pixAxios from '@/axios/pixAxios.js';
import pixUtils from '@/services/common/pix.utils.js';
import jllLocalstorageManager from 'jll-localstorage-manager';
import Console from '@/shared/console';
import buildVariables from '../../../buildVariables.js';

const loadedLanguages = [];
let i18n;

const setI18nLanguage = (lang) => {
  i18n.locale = lang;
  store.dispatch('setLangCode', lang);
  // pixAxios.defaults.headers.common['Accept-Language'] = lang; // UNNECESSARY
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
};

const loadLanguageAsync = () => {
  const lang = store.getters.langCode;
  const env = store.getters['authModule/instance'];
  const localStorageKey = `PixTranslations_${env}_${lang}`;

  if (loadedLanguages.includes(lang)) {
    if (i18n.locale !== lang) {
      setI18nLanguage(lang);
    }
    return Promise.resolve();
  }

  const translationFromLocalStorage = jllLocalstorageManager.getWithoutInstanceLang(localStorageKey);

  if (translationFromLocalStorage?.buildNumber === buildVariables.buildNumber) {
    loadedLanguages.push(lang);
    i18n.setLocaleMessage(lang, translationFromLocalStorage.translations);
    setI18nLanguage(lang);
    store.dispatch('setTranslationIsLoaded', true);
    return Promise.resolve();
  } else if (translationFromLocalStorage) {
    jllLocalstorageManager.remove(localStorageKey);
  }

  return new Promise((resolve, reject) => {
    if (store.getters['authModule/fullInstance']) {
      pixAxios
        .get(`/api/TranslationConfigJS/GetConfigTranslationsJS?LangCode=${lang}&Instance=${store.getters['authModule/fullInstance']}`)
        .then((response) => {
          const info = response.data;

          if (info) {
            const rootTranslations = pixUtils.getObjectFromKeysString(info);
            loadedLanguages.push(lang);
            i18n.setLocaleMessage(lang, rootTranslations);
            setI18nLanguage(lang);

            const localStorageTranslations = {
              buildNumber: buildVariables.buildNumber,
              translations: rootTranslations,
            };
            jllLocalstorageManager.setWithoutInstanceLang(localStorageKey, localStorageTranslations, 1000 * 3600 * 24);
          } else {
            store.dispatch('toastModule/error', 'Error loading language translations');
          }
          store.dispatch('setTranslationIsLoaded', true);

          resolve();
        })
        .catch(() => {
          store.dispatch('toastModule/error', 'Error loading language translations');
          reject();
        });
    } else {
      Console.error('Instance was not set when trying to fetch translations');
      resolve();
    }
  });
};

export default {
  init: (Vue) => {
    store.dispatch('setLangCode', i18nOptions.locale);
    Vue.use(VueI18n);
    i18n = new VueI18n(i18nOptions);
    return i18n;
  },
  setI18nLanguage,
  loadLanguageAsync,
};
